import React, { useState } from "react";
import { Button, Tooltip } from "@material-ui/core";

const ToggleButton = ({ title, icon, onToggle, defaultState = false, compact = false }) => {
    const [isToggled, setIsToggled] = useState(defaultState);

    const handleToggle = () => {
        const newState = !isToggled;
        setIsToggled(newState);
        if (onToggle) {
            onToggle(newState);
        }
    };

    return (
        <Tooltip title={title} arrow placement="bottom">
            <Button
                variant="contained"
                onClick={handleToggle}
                style={{
                    backgroundColor: isToggled ? "rgb(34, 41, 180)" : "#013f82",
                    color: "rgb(169, 227, 251)",
                    borderRadius: "20px",
                    border: isToggled ? "1px solid rgb(41, 215, 224)" : "2px solid transparent",
                    boxShadow: isToggled ? "0px 0px 8px rgb(168, 224, 248)" : "none",
                    padding: compact ? "4px 8px" : "4px 16px",
                    textTransform: "none",
                    fontWeight: "normal",
                    minHeight: "30px",
                    minWidth: compact ? "60px" : "120px",
                    fontSize: "14px"
                }}
            >
                {icon ? (
                    <img 
                        src={icon} 
                        alt={title || "Icon"} 
                        style={{ 
                            width: "28px", 
                            height: "28px",
                            filter: "brightness(0) saturate(100%) invert(88%) sepia(15%) saturate(1234%) hue-rotate(169deg) brightness(101%) contrast(101%)"
                        }} 
                    />
                ) : (
                    title
                )}
            </Button>
        </Tooltip>
    );
};

export default ToggleButton;